import { useCallback } from 'react';
import useCustomerContextDrawer from './useCustomerContextDrawer';

/**
 * Profile panel controls — wraps customer context drawer with toggle API
 * used by ChatPanel header avatar click.
 */
export default function useProfilePanel(activeUserPhone) {
  const drawer = useCustomerContextDrawer(activeUserPhone);

  const toggle = useCallback(() => {
    if (!activeUserPhone) return;
    if (drawer.isOpen) {
      drawer.close();
    } else {
      drawer.open();
    }
  }, [activeUserPhone, drawer.isOpen, drawer.close, drawer.open]);

  return {
    isOpen: drawer.isOpen,
    activeTab: drawer.activeTab,
    open: drawer.open,
    close: drawer.close,
    setTab: drawer.setTab,
    toggle,
    isInlineLayout: drawer.isInlineLayout,
    isUserListCollapsed: drawer.isUserListCollapsed,
    /** @deprecated use isInlineLayout */
    isLargeScreen: drawer.isInlineLayout,
  };
}
